"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InANutshellAvailability = void 0;
var InANutshellAvailability;
(function (InANutshellAvailability) {
    InANutshellAvailability["AVAILABLE"] = "available";
    InANutshellAvailability["NOT_AVAILABLE"] = "not available";
})(InANutshellAvailability || (exports.InANutshellAvailability = InANutshellAvailability = {}));
//# sourceMappingURL=InANutshellEnums.js.map